import { createSlice } from '@reduxjs/toolkit';

import { PromotionState } from '../interfaces';

const initialState: PromotionState = {
    promotionDetail: null,
    promotionSelectedId: null,
};

const userSlice = createSlice({
  name: 'promotions',
  initialState: initialState,
  reducers: {
    setPromotionDetail: (state, action) => {
        state.promotionDetail = action.payload;
    },
    setPromotionSelectedId: (state, action) => {
      state.promotionSelectedId = action.payload;
  },
  },
});

export const { setPromotionDetail, setPromotionSelectedId } = userSlice.actions;
export default userSlice.reducer;

export function getPromotionSelectedId(state) {
    return state.promotions.promotionSelectedId;
}

export function getPromotionDetail(state) {
  return state.promotions.promotionDetail;
}